import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../../app.reducers';
import { Observable } from 'rxjs';
import { SetAdminPortfoliosFilterAction, ToggleAdminPortfolioActiveStatusAction } from '../../admin-store';
import { Workspace } from '../../../shared/models/workspace';
import { getAdminPortfolioFilterSettings, getSortedAdminWorkspaces } from '../../admin-store/admin.selectors';

@Component({
  templateUrl: './admin-portfolios.component.html',
  styleUrls: ['./admin-portfolios.component.scss'],
  standalone: false
})

export class AdminPortfoliosComponent implements OnInit {
  workspaces$: Observable<Workspace[]>;
  portfolioFilterSettings$: Observable<string>;

  constructor(private store: Store<AppState>) {
    this.workspaces$ = this.store.pipe(select(getSortedAdminWorkspaces));
    this.portfolioFilterSettings$ = this.store.pipe(select(getAdminPortfolioFilterSettings));
  }

  ngOnInit() {
    this.portfolioFilterSettings$.subscribe(filter => {
      this.store.dispatch(new SetAdminPortfoliosFilterAction(filter));
    });
  }

  onFilterChanged(filter: string) {
    this.store.dispatch(new SetAdminPortfoliosFilterAction(filter));
  }

  onDeactivatePortfolio(workspaceId: string) {
    this.store.dispatch(new ToggleAdminPortfolioActiveStatusAction({ workspaceId: workspaceId, isActive: false }));
  }

  onReactivatePortfolio(workspaceId: string) {
    this.store.dispatch(new ToggleAdminPortfolioActiveStatusAction({ workspaceId: workspaceId, isActive: true }));
  }
}
